module.exports = {"id":"212491","name":"Arthur Masuaku","rating":"76","photo":"./data/images/photos/3/212491.png","club":{"name":"West Ham Utd","logo":"./data/images/clubs/WestHamUtd.png"},"positions":["DLG","DG","MG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ArthurMasuaku0.json
// module id = 478
// module chunks = 0